import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import type { Settings } from 'react-slick';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useDemographicsFilter } from '../../hooks/demographic';
import { createClassName, createStyleHelper } from '../../utils/class-names';
import { exists } from '../../utils/filters';
import { Slide } from '../slide/slide';
import type { SlideType } from '../slide/slide.interface';

import type { IBannerCollection } from './carousel.interface';
import styles from './carousel.module.scss';
const style = createStyleHelper(styles, 'carousel');

export interface ICarouselProps {
    className?: string;
    overrideSliderSettings?: Settings;
    collection: IBannerCollection;
    type?: SlideType;
}

const defaultSliderSettings: Settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
};

export const Carousel: FunctionComponent<ICarouselProps> = ({
    className,
    overrideSliderSettings,
    collection,
    type,
}) => {
    const sliderSettings = {
        ...defaultSliderSettings,
        ...overrideSliderSettings,
    };
    const banners = useMemo(() => collection.banners?.filter(exists) ?? [], [collection]);
    const filteredBanners = useDemographicsFilter(banners);

    return (
        <div className={createClassName([className, style()])}>
            <Slider {...sliderSettings}>
                {filteredBanners.map((banner) => (
                    <Slide key={banner.id} slide={banner} type={type} />
                ))}
            </Slider>
        </div>
    );
};
